import helpers from '../common/helpers';

(function ($) {
  "use strict";

  const cntsNavigation = {
    leftNavContainer: $('#navbar-expand').offset().left, 
    init: function () {
      cntsNavigation.initDropDownMenu();
    },
    initDropDownMenu: function () {
      let $dropdownOpener = $('#navbar-expand .nav-link');

      $dropdownOpener.on('click', (e) => {        
        let $thisItem = $(e.currentTarget);

        if(!helpers.isMobile() && cnts.windowWidth > '992') {
          let left = $thisItem.offset().left - cntsNavigation.leftNavContainer;
  
          if($thisItem.parent().hasClass('dropdown')){
            $thisItem.next().find('.nav-item__submenu').css('left', left);
          }
        }
      })
    }
  };

  $(document).ready(function () {
    cntsNavigation.init();
  });

})(jQuery);